import React from 'react';
import {Polar} from 'react-chartjs-2';

const data = {
  datasets: [{
    data: [
      11,
      16,
      7,
      3,
      14
    ],
    backgroundColor: [
      '#FF6384',
      '#4BC0C0',
      '#FFCE56',
      '#E7E9ED',
      '#36A2EB'
    ],
    label: 'My dataset' // for legend
  }],
  labels: [
    'Pipeline',
    'Tasks',
    'Estimated',
    'Bugs',
    'Delivered'
  ]
};

const options={
  legend: {
      display: false,
  },
};

export default function PolarChart(){
    return (
      // <div>
        <Polar data={data}  options={options}/>
      // </div>
    )
}